export default {
  methods: {
    getStudentType() {
      // Por enquanto estamos somente utilizando o operador ternário pois no momento somente temos dois
      // tipos de estudantes (com acessibilidade autidiva e sem). Quando formos implementar a acessibilidade
      // visual, vamos refatorar esse método.
      return this.$store.state._core.user.accessibility.signLanguageEnabled
        ? 'auditory'
        : 'default';
    }
  }
};
